import FolderApi from '@/api/folder'
import router from '@/router'

const setFoldersAction = ({ commit }, payload) => {
  commit('setFolders', payload)
}

const getFoldersAction = async ({ commit }, params) => {
  const folders = await FolderApi.getFolders(params)
  if (router.currentRoute.name === 'SharedWithMe') return
  commit('setFolders', folders)
}

export default {
  setFoldersAction,
  getFoldersAction,
}
